import "./App.css";
import Home from "./Components/Home";
import About from "./Components/About";
import Navbar1 from "./Components/Navbar1";
import Contact from "./Components/Contact";
import Blog from "./Components/Blog";
import Story from "./Components/Story";
import Service from "./Components/Service";
import Languageprogram from "./Components/Languageprogram";
import { BrowserRouter, Route, Navigate, Routes } from "react-router-dom";
import Projects from "./Components/Projects";
import Readmore from "./Components/Readmore";
import Notfoundpage from "./Components/Notfoundpage";
import MovieReview from "./Components/MovieReview";
// import Userdata from './Components/Userdata.json';
// import { useAuth0 } from "@auth0/auth0-react";
import Loginsetup from "./Components/Loginsetup";


function App() {
  // const { loginWithRedirect } = useAuth0();
  // const { logout } = useAuth0();
  // const { isAuthenticated } = useAuth0();

  return (
    <div>
      {/* {isAuthenticated ? ( */}
        <BrowserRouter>
          <Navbar1 />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/About" element={<About />} />
            <Route path="/Contact" element={<Contact />} />
            <Route path="/Projects" element={<Projects />} />
            <Route path="/Blog" element={<Blog />} />
            <Route path="/Story" element={<Story />} />
            <Route path="/Languageprogram" element={<Languageprogram />} />
            <Route path="/Partners" element={<Service />} />
            <Route path="/Readmore" element={<Readmore />} />
            <Route path="/MovieReview" element={<MovieReview />} />
            <Route path="/Notfoundpage" element={<Notfoundpage />} />
            <Route path="/Loginsetup" element={<Loginsetup />} />
            
            <Route path="/*" element={<Navigate to="/Notfoundpage" />} />
          </Routes>
        </BrowserRouter>
      {/* ) : ( */}
        {/* <Loginsetup/> */}
      {/* )} */}
    </div>
  );
}

export default App;
